import { render, staticRenderFns } from "./BusinessDetailsEditor.vue?vue&type=template&id=79b01130"
import script from "./BusinessDetailsEditor.vue?vue&type=script&lang=js"
export * from "./BusinessDetailsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports